import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { IVaultOrg } from './interfaces';

const basePath = '/orgs';

/* eslint-disable implicit-arrow-linebreak */

export const getVaultOrgProducts = (): AxiosPromise<IApiResponse<Array<string>>> =>
  vaultApi.getInstance().get(`${basePath}/products`);

export const getVaultOrgs = (productName: string = null): AxiosPromise<IApiResponse<Array<IVaultOrg>>> =>
  vaultApi.getInstance().get(`${basePath}${productName ? `?productName=${productName}` : ''}`);
